import React, { useEffect, memo, Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import VerticalNav from "../SidebarStyle/vertical-nav";

//scrollbar
import Scrollbar from "smooth-scrollbar";

// Import selectors & action from setting store
import * as SettingSelector from "../../../../store/setting/selectors";

// Redux Selector / Action
import { useSelector } from "react-redux";
import Logo from "../../../../assets/images/willowood.png";

// import SidebarDark from '../../components/settingoffcanvas'

// export const SidebarDark =() =>{

// }

const Sidebar = memo((props) => {
  const sidebarColor = useSelector(SettingSelector.sidebar_color);
  const sidebarHide = useSelector(SettingSelector.sidebar_show); // array
  const sidebarType = useSelector(SettingSelector.sidebar_type); // array
  const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);
  const [isSidebarCollapse, setIsSidebarCollapse] = React.useState(false);
  const [showCollapseButton, setShowCollapseButton] = React.useState(false);

  const navigate = useNavigate();
  const minisidebar = () => {
    document.getElementsByTagName("ASIDE")[0].classList.toggle("sidebar-mini");
    setIsSidebarCollapse(
      document
        .getElementsByTagName("ASIDE")[0]
        .classList.contains("sidebar-mini"),
    );
  };
  useEffect(() => {
    Scrollbar.init(document.querySelector("#my-scrollbar"));

    window.addEventListener("resize", () => {
      const tabs = document.querySelectorAll(".nav");
      const sidebarResponsive = document.querySelector(
        '[data-sidebar="responsive"]',
      );
      if (window.innerWidth < 1025) {
        Array.from(tabs, (elem) => {
          if (
            !elem.classList.contains("flex-column") &&
            elem.classList.contains("nav-tabs") &&
            elem.classList.contains("nav-pills")
          ) {
            elem.classList.add("flex-column", "on-resize");
          }
          return elem.classList.add("flex-column", "on-resize");
        });
        if (sidebarResponsive !== null) {
          if (!sidebarResponsive.classList.contains("sidebar-mini")) {
            sidebarResponsive.classList.add("sidebar-mini", "on-resize");
          }
        }
      } else {
        Array.from(tabs, (elem) => {
          if (elem.classList.contains("on-resize")) {
            elem.classList.remove("flex-column", "on-resize");
          }
          return elem.classList.remove("flex-column", "on-resize");
        });
        if (sidebarResponsive !== null) {
          if (
            sidebarResponsive.classList.contains("sidebar-mini") &&
            sidebarResponsive.classList.contains("on-resize")
          ) {
            sidebarResponsive.classList.remove("sidebar-mini", "on-resize");
          }
        }
      }
    });
  });

  return (
    <Fragment>
      <aside
        className={`d-flex flex-column ${sidebarColor} ${sidebarType.join(" ")} ${sidebarMenuStyle} ${sidebarHide.join(" ") ? "sidebar-none" : "sidebar"}   sidebar-base `}
        data-sidebar="responsive"
        onMouseOver={() => setShowCollapseButton(true)}
        onMouseLeave={() => setShowCollapseButton(false)}
      >
        {showCollapseButton && (
          <div
            onClick={minisidebar}
            className="sidebar-toggle position-absolute top-50"
            style={{ left: "94%", zIndex: "100", cursor: "pointer " }}
          >
            <i className="icon d-flex justify-content-center align-items-center">
              {!isSidebarCollapse ? (
                <svg
                  width="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M12 22.0002C6.485 22.0002 2 17.5142 2 12.0002C2 6.48624 6.485 2.00024 12 2.00024C17.514 2.00024 22 6.48624 22 12.0002C22 17.5142 17.514 22.0002 12 22.0002Z"
                  ></path>
                  <path
                    d="M13.4425 16.2208C13.2515 16.2208 13.0595 16.1478 12.9135 16.0018L9.42652 12.5318C9.28552 12.3908 9.20652 12.1998 9.20652 11.9998C9.20652 11.8008 9.28552 11.6098 9.42652 11.4688L12.9135 7.99683C13.2065 7.70483 13.6805 7.70483 13.9735 7.99883C14.2655 8.29283 14.2645 8.76783 13.9715 9.05983L11.0185 11.9998L13.9715 14.9398C14.2645 15.2318 14.2655 15.7058 13.9735 15.9998C13.8275 16.1478 13.6345 16.2208 13.4425 16.2208Z"
                    fill="currentColor"
                  ></path>
                </svg>
              ) : (
                <svg
                  width="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.4"
                    d="M12 1.99976C17.515 1.99976 22 6.48576 22 11.9998C22 17.5138 17.515 21.9998 12 21.9998C6.486 21.9998 2 17.5138 2 11.9998C2 6.48576 6.486 1.99976 12 1.99976Z"
                  ></path>
                  <path
                    d="M10.5575 7.77917C10.7485 7.77917 10.9405 7.85217 11.0865 7.99817L14.5735 11.4682C14.7145 11.6092 14.7935 11.8002 14.7935 12.0002C14.7935 12.1992 14.7145 12.3902 14.5735 12.5312L11.0865 16.0032C10.7935 16.2952 10.3195 16.2952 10.0265 16.0012C9.73448 15.7072 9.73548 15.2322 10.0285 14.9402L12.9815 12.0002L10.0285 9.06017C9.73548 8.76817 9.73448 8.29417 10.0265 8.00017C10.1725 7.85217 10.3655 7.77917 10.5575 7.77917Z"
                    fill="currentColor"
                  ></path>
                </svg>
              )}
            </i>
          </div>
        )}
        <div className="sidebar-header d-flex align-items-center justify-content-center px-3">
          <Link
            to="/dashboard"
            className="navbar-brand d-flex align-items-center w-100 justify-content-center"
          >
            <img
              src={Logo}
              width="190px"
              height="190px"
              className="navbar-brand-img"
              alt="..."
              style={{
                display: "block",
                paddingLeft: "5px",
                paddingRight: "5px",
              }}
            />
            <h4 className="logo-title mb-0">{props.app_name}</h4>
          </Link>
          <div
            className="sidebar-toggle"
            data-toggle="sidebar"
            data-active="true"
            onClick={() => navigate(-1)}
          >
            <i className="icon">
              <svg
                width="20"
                className="icon-20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 12.2744L19.25 12.2744"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
                <path
                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </i>
          </div>
        </div>
        <div
          className="pt-0 sidebar-body data-scrollbar sidebar-ul-scroll"
          data-scroll="1"
          id="my-scrollbar"
        >
          <div className="sidebar-list navbar-collapse" id="sidebar">
            <VerticalNav />
          </div>
        </div>
        <div className="sidebar-footer"></div>
        <p
          className="mx-auto w-100 text-center pe-4 py-2 mb-0 text-default item-name align-self-end"
          style={{
            backgroundColor: "#fefffe",
            position: "absolute",
            bottom: "0%",
            color: "#8A92A6",
            fontSize: "0.9rem",
          }}
        >
          Powered By{" "}
          <Link
            to={"https://6thlabs.com"}
            style={{ color: "#8A92A6", textDecoration: "underline" }}
            target="_blank"
          >
            6thlabs
          </Link>
        </p>
      </aside>
    </Fragment>
  );
});

export default Sidebar;
